import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";

export const handleTrackingEvent = (
  event: USER_TRACKING_EVENTS,
  data: object
) => {
  addEventToTracking(event, {
    product: "villa",
    ...data
  });
};
